module.exports = __webpack_public_path__ + "static/media/gallery-1.86d6d3a2.jpg";